
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M12 .25C18.49.25 23.75 5.51 23.75 12S18.49 23.75 12 23.75.25 18.49.25 12 5.51.25 12 .25zm0 1C6.063 1.25 1.25 6.063 1.25 12S6.063 22.75 12 22.75 22.75 17.937 22.75 12 17.937 1.25 12 1.25zM11.25 10c.647 0 1.18.492 1.244 1.122l.006.128V15a1 1 0 00.883.993L13.5 16h.75v1h-.75a2 2 0 01-1.995-1.85L11.5 15v-3.75a.25.25 0 00-.193-.243L11.25 11h-.75v-1h.75zm.375-4l.123.007a1.125 1.125 0 11-.246 0L11.625 6z","fill":"#FFF","fill-rule":"evenodd"}})])
          )
        }
      }
    